export const B2B_INFO = 'B2B_INFO';
export function setB2bInfo(b2bInfo) {
  return {
    type: B2B_INFO,
    payload: b2bInfo
  }
}